import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot", "submit", "submitLabel"]

  static values = {
    submitLabel: String,
    chooseSlot: String
  }

  selectSlot () {
    const selectedSlot = this.slotTargets.find((slot) => slot.checked)?.value
    const activeClass = "active"

    this.slotTargets.forEach((slot) => {
      slot.closest("label")?.classList.toggle(activeClass, slot.checked)
    })

    if (!selectedSlot) {
      this.submitTarget.disabled = true
      this.submitLabelTarget.textContent = this.chooseSlotValue
      return
    }

    this.submitTarget.disabled = false
    this.submitLabelTarget.textContent = this.submitLabelValue.replace("%{slot}", selectedSlot)
  }
}
